module.exports = __webpack_public_path__ + "static/media/wave.859a5571.svg";